import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Redirect } from "react-router-dom";
import clickOutside from "react-click-outside";

import SideInfo from "../SideInfo";
import Pages from "../../../routes/sub/vAppointment";
import { ReactComponent as Close} from "../../../svgs/close.svg";
import styles from "./desktopPopUp.module.css";
import { ReactComponent as RightArrow } from "../../../svgs/leftlinearrow.svg";
import { go } from "../../../routes/index";
import { goBack } from "routes/utils";
import { isDesktop } from "config";


const smallWindow = window.innerHeight < 700;

class DesktopPopUp extends Component {
  // equivalent to cancelling appointment
  handleClickOutside = () => {
    // Changing popup to not close when clicking ouside until rework.
    // this.props.clearAppointment();
    this.props.closePopUp();
  };
  handleClickBack = () => {
    goBack();
  }

  render() {
    const { closePopUp, doctor, appointment, practiceName, match, outside } = this.props;
    const showSide = !match.url.match(
      /(confirmation|verification|processing|register)$/,
    );
    const hideButton = match.url.match(/(processing|register)$/);
    const hideBackButton = window.location.pathname.includes(`patient-selection`);//match.url.match(/(patient-selection)$/);
    if (!appointment) {
      return <Redirect to={`/practice-profile/${match.params.orgId}`} />;
    }
    return (
      <div
        className={classnames(styles.popUpContainerOuter, { [styles.smallWindow]: smallWindow })}
      >  
        <div className={styles.popUpContainer}>
          {showSide && (
            <SideInfo
              doctor={doctor}
              practiceName={practiceName}
              appointment={appointment}
              closePopUp={closePopUp}
            />
          )}
          {/* eslint-disable-next-line */}
            <a
              className={classnames(styles.buttonBack, { [styles.hidden]: hideBackButton || hideButton })}
              style={{left: showSide ? "45%" : "2rem"}}
              onClick={this.handleClickBack}
            >
              <RightArrow className={styles.iconBack} />
            </a> 
          
          {/* eslint-disable-next-line */} 
          <a
            className={classnames(styles.button, { [styles.hidden]: hideButton })}
            onClick={this.handleClickOutside}
          >
            <Close className={styles.icon} />
          </a>
          <div
            id="nw_pop_up"
            className={classnames(styles.innerPopUpContainer, { [styles.setSize]: showSide })}
            style={{ display: isDesktop() && match.url.match("payment") ? "block" : "flex"}}
          >
            <Pages />
          </div>
        </div>
      </div>
    );
  }
}

DesktopPopUp.propTypes = {
  closePopUp: PropTypes.func.isRequired,
  //doctor: doctorProfilePropType.isRequired,
  practiceName: PropTypes.string.isRequired,
  //appointment: PropTypes.string.isRequired,
  clearAppointment: PropTypes.func.isRequired,
};

export default clickOutside(DesktopPopUp);
